import { FC, useState, ReactNode } from 'react';
import { IconBuilding } from '@tabler/icons-react';

type ImageProps = {
    src: string;
    alt: string;
    className?: string;
    classNameLqip?: string;
    renderErrorIcon?: ReactNode;
    /** optional low-quality image placeholder (data URL or small image URL) */
    lqip?: string;
};

const ImageComponent: FC<ImageProps> = ({ src, lqip, alt, className = "", classNameLqip = "", renderErrorIcon }) => {
    const [hasError, setHasError] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div className={`relative overflow-hidden size-full ${className}`}>
            {hasError ? (
                <div className='size-full flex items-center justify-center bg-primary/5 text-primary'>
                    {renderErrorIcon ? renderErrorIcon : <IconBuilding className='size-8' />}
                </div>
            ) : (
                // render lqip placeholder (if provided) beneath the real image
                <>
                    {lqip && (
                        <img
                            src={lqip}
                            alt={alt ? `${alt} (preview)` : 'preview'}
                            aria-hidden
                            className={`${classNameLqip} absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-out ${isLoaded ? 'opacity-0' : 'opacity-100'}`}
                            style={{ filter: 'blur(12px)', transform: 'scale(1.03)' }}
                        />
                    )}

                    <img
                        className={`relative w-full h-full object-cover transition-opacity duration-500 ease-out ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
                        src={src}
                        alt={alt}
                        onError={() => setHasError(true)}
                        onLoad={() => setIsLoaded(true)}
                    />
                </>
            )}
        </div>
    );
};

export default ImageComponent;

/* 
    El componente maneja errores de carga de imagen y muestra un icono alternativo si la imagen no se puede cargar.
    Puedes personalizar el icono de error pasando un ReactNode al prop renderErrorIcon.

    USO:
    import Image from 'src/components/Image';
    <Image src={cover} alt={name} className="additional-classes-if-needed" />


    Daniel Bonilla - Septiembre 2025
*/